import type { ComponentPropsWithRef } from "react";
import { Collapse, CollapseContent, CollapseTrigger } from "@/components/ui/collapse.tsx";
import type { Nullable } from "@/types";
import { formatShortDate } from "@/utils/formatters.ts";
import { cn } from "@/utils/style.ts";
import { EventLogTime } from "./event-log-item.tsx";

type DetailItemRootProps = ComponentPropsWithRef<"li">;
export function DetailItemRoot({ className, ...props }: DetailItemRootProps) {
    return <li {...props} className={cn("detail-item", className)} />;
}

type DetailItemNameProps = ComponentPropsWithRef<"span">;
export function DetailItemName({ className, ...props }: DetailItemNameProps) {
    return <span {...props} className={cn("detail-item__name", className)} />;
}

type DetailItemPreviewProps = ComponentPropsWithRef<"span">;
export function DetailItemPreview({ className, ...props }: DetailItemPreviewProps) {
    return <span {...props} className={cn("detail-item__data-preview", className)} />;
}

type DetailItemJsonProps = ComponentPropsWithRef<"pre">;
export function DetailItemJson({ className, ...props }: DetailItemJsonProps) {
    return <pre {...props} className={cn("detail-item__json", className)} />;
}

type DetailItemProps = {
    timestamp: Nullable<number>;
    name: string;
    data: Record<string, unknown>;
};

export default function DetailItem({ timestamp, name, data }: DetailItemProps) {
    return (
        <DetailItemRoot>
            <Collapse>
                <CollapseTrigger className="detail-item__trigger">
                    {timestamp !== null && <EventLogTime>{formatShortDate(timestamp)}</EventLogTime>}
                    <DetailItemName>{name}</DetailItemName>
                    <DetailItemPreview>{JSON.stringify(data)}</DetailItemPreview>
                </CollapseTrigger>
                <CollapseContent>
                    <DetailItemJson>{JSON.stringify(data, null, 2)}</DetailItemJson>
                </CollapseContent>
            </Collapse>
        </DetailItemRoot>
    );
}
